export enum AgentDispatchMode {
  PoolLoadBalanced = "PoolLoadBalanced",
  Failover = "Failover",
}
